import { useQuery } from '@apollo/client';
import { useEffect, useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';

import insightPurchaseImage from '../../assets/completed-steps-animate.svg';
import Button from '../../components/inputs/Button';
import { PURCHASED_AUDIENCES_QUERY } from '../../queries/audienceQueries';
import ErrorText from '../../components/ErrorText';

export default function AudiencePurchasePrompt() {
  const navigate = useNavigate();
  const { audienceId } = useParams();
  const [matchedAudience, setMatchedAudience] = useState(null);

  const { loading, error, data } = useQuery(PURCHASED_AUDIENCES_QUERY, {
    fetchPolicy: 'cache-and-network',
  });
  const audiences = data?.purchasedAudiences;

  useEffect(() => {
    function navigateToMyWorkAudiences() {
      navigate('../../../mywork/saved-audiences');
    }
    if (error) {
      navigateToMyWorkAudiences();
    }
    if (!loading && audiences && audiences?.length) {
      const foundInAudiences = audiences.find(({ id }) => audienceId === id);
      if (!foundInAudiences) {
        navigateToMyWorkAudiences();
      }
      setMatchedAudience(foundInAudiences);
    }
  }, [error, audienceId, loading, audiences, navigate]);

  return (
    <div className="w-full h-full flex flex-col overflow-hidden justify-center items-center">
      <div className="flex items-center mb-8">
        <img
          className="h-80 mx-auto"
          src={insightPurchaseImage}
          alt="one out of six light bulbs lit up"
        />
      </div>
      <p className="mt-1">
        Audience name for profile report:{' '}
        <span className="font-bold">{matchedAudience?.name}</span>
      </p>
      <div className="flex flex-col items-center gap-8 mb-24 mt-8">
        <Link
          to="../audience/order"
          state={{
            orderDetails: {
              coreProductName: 'audience-profile',
              audienceId: matchedAudience?.id,
              audienceName: matchedAudience?.name,
              recordsIncluded: matchedAudience?.recordsIncluded,
            },
          }}
        >
          <Button type="button" primary>
            Generate Profile Report
          </Button>
        </Link>
      </div>
    </div>
  );
}
